import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-section-headline',
    templateUrl: './section-headline.component.html',
    styleUrls: ['./section-headline.component.css'],
})
export class SectionHeadlineComponent implements OnInit {

    @Input() position = 'left';

    constructor() {
    }

    ngOnInit() {
    }

}
